export const campaignsOriginProposalsOptions = [
    {label: 'Propostas AUTOCONTRATAÇÃO', value: 1},  
    { label: 'Propostas DIGITAÇÃO', value: 2 }
]